import { Component, component, property } from '../../../../concepts/objects';
import { Frame } from '../Frame';
import { FrameAddon } from '../FrameAddon';
import { ActivityFrameAddonPropertyLayout } from './ActivityFrameAddonPropertyLayout';

export const ActivityFrameAddonLayout = (object: ActivityFrameAddon) => {
    const { base, title } = object.parentFrame.layout;

    // const padding = 0.1875;
    // const em = FrameLabelFontSizeAttr.get(object.parentFrame);

    // const { w: menuWidth } = TextRuler.measureSize('Host—', object.parentFrame.field('label') as TextField);
    // const menuHeight = label.height;
    // const menu = new Rect(
    //     base.width - menuWidth,
    //     -menuHeight,
    //     menuWidth,
    //     menuHeight,
    // );

    // const herd = FrameUserElevatedAttr.get(object.parentFrame)
    //     ? new Rect(base.width - labelSize - labelSize - 10, -(labelSize + 5), labelSize, labelSize)
    //     : Rect.empty;

    // const hideShow = FrameUserElevatedAttr.get(object.parentFrame)
    //     ? new Rect(base.width - labelSize, -(labelSize + 5), labelSize, labelSize)
    //     : Rect.empty;

    return { base };
};

export type ActivityFrameAddonLayout = ReturnType<typeof ActivityFrameAddonLayout>;

const activityFrameAddonDef = {
    name: 'ActivityFrameAddon',
    implements: [FrameAddon],
    propertyLayout: ActivityFrameAddonPropertyLayout,
};

@component(activityFrameAddonDef)
export class ActivityFrameAddon extends Component implements FrameAddon {

    @property({ type: 'boolean', default: false })
    public hidden: boolean;

    public get parentFrame() {
        return this.parent?.as(Frame);
    }

    public get layer() {
        return 'top' as const;
    }

    public get layout() {
        return ActivityFrameAddonLayout(this);
    }

    // public test(mpt: Point): boolean {
    //     const { menu } = this.layout;
    //     const lpt = this.parentFrame.toRelative(mpt);
    //     // return herd.contains(lpt) || hideShow.contains(lpt);
    //     return menu.contains(lpt);
    // }

    // public testInteraction({ type, mpt }: PotentialInteraction, _force?: boolean, _selected?: boolean): [boolean, string] {
    //     const { menu } = this.layout;
    //     const lpt = this.parentFrame.toRelative(mpt);

    //     if (type === 'invoke' && menu.contains(lpt)) {
    //         return [true, 'menu'];
    //     }
    //     // if (type === 'invoke' && herd.contains(lpt)) {
    //     //     return [true, 'herd'];
    //     // }
    //     // if (type === 'invoke' && hideShow.contains(lpt)) {
    //     //     return [true, 'hideShow'];
    //     // }

    //     return [false, 'none'];
    // }
}
